import { Modal, ModalContent, ModalHeader, ModalBody } from "@nextui-org/react";
import { ExerciseFormAnalyzer } from "@/components/ExerciseFormAnalyzer";
import { MediaPipeExerciseAnalyzer } from "@/components/ExerciseFormAnalyzer/MediaPipeExerciseAnalyzer";
import { AnalysisResult } from "@/lib/exercise-form-analyzer-client";
import { BasicUserType } from "@/types/user";

interface ExerciseFormAnalyzerModalProps {
  isOpen: boolean;
  onClose: () => void;
  user: BasicUserType | null;
  onAnalysisComplete?: (result: AnalysisResult) => void;
}

export const ExerciseFormAnalyzerModal = ({
  isOpen,
  onClose,
  user,
  onAnalysisComplete
}: ExerciseFormAnalyzerModalProps) => {
  const handleAnalysisComplete = (result: AnalysisResult) => {
    if (onAnalysisComplete) {
      onAnalysisComplete(result);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      size="3xl"
      className="bg-secondary"
    >
      <ModalContent>
        <ModalHeader className="text-xl">Exercise Form Analyzer (MediaPipe)</ModalHeader>
        <ModalBody className="pb-6">
          <MediaPipeExerciseAnalyzer
            onAnalysisComplete={handleAnalysisComplete}
            onClose={onClose}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ExerciseFormAnalyzerModal;